import React, { useCallback, useState } from 'react'
import { useDispatch } from 'react-redux'
import Button from '../../ui/button'
import TextField from '../../ui/text-field'
import { addPlayer } from './gameSlice'
import styles from './JoinGameForm.module.css'

export default function JoinGameForm() {
    const [name, setName] = useState("")
    const trimedName = name.trim()
    const dispatch = useDispatch()
    const submit = useCallback(() => {
        if (trimedName.length === 0) return;
        dispatch(addPlayer({ name: trimedName }))
    }, [trimedName, dispatch])

    return (
        <div className={styles.joinGame}>
            <TextField label="Your name" onChange={(e) => setName(e.target.value)} />
            <Button variant="outlined" onClick={submit} disabled={trimedName.length === 0}>
                Join
            </Button>
        </div>
    )
}